<template>
  <div
    style="
      height: 940px;
      pointer-events: all;
      background-color: #070b20;
      color: #fff;
      padding-top: 120px;
    "
  >
    <el-row :gutter="20">
      <el-col span="12">
        <div style="width: 100%; height: 100%">
          <video
            width="100%"
            height="100%"
            autoplay="autoplay"
            style="width: 100%; height: 100%"
          >
            <source type="video/mp4" src="/static/1.mp4" />
          </video>
        </div>
      </el-col>
      <el-col span="12">
        <div style="width: 100%; height: 100%">
          <video
            width="100%"
            height="100%"
            autoplay="autoplay"
            style="width: 100%; height: 100%"
          >
            <source type="video/mp4" src="/static/2.mp4" />
          </video>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'Mp4Index',
  components: {},
  data() {
    return {}
  },
  mounted() {
    console.log('【↑↑↑】', this.$options.name)
  },
  beforeDestroy() {
    console.log('【↓↓↓】', this.$options.name)
  },
}
</script>

<style scoped></style>

<style></style>



// WEBPACK FOOTER //
// src/components/mp4/Index.vue